import React, { useState } from 'react';

//dashboard tabs
import AllCampaignTable from '../../DashboardComponent/AllCampaignTable';
import CpaTable from '../../DashboardComponent/CpaTable';
import CpcTable from '../../DashboardComponent/CpcTable';
import CppTable from '../../DashboardComponent/CppTable';

//campaigns tabs
import AllCampaignTab from '../../CampaignsComponent/AllCampaignTab';
import CpaTab from '../../CampaignsComponent/CpaTab';
import CpcTab from '../../CampaignsComponent/CpcTab';
import CppTab from '../../CampaignsComponent/CppTab';


//billing tabs
import AllBilling from "../../BillingComponents/AllBilling";
import ApprovedBilling from "../../BillingComponents/ApprovedBilling";
import PendingBilling from "../../BillingComponents/PendingBilling";
import RejectedBilling from "../../BillingComponents/RejectedBilling";

import { LayoutContainer, TabContainer, TabNavigationTab } from './TabStyles';

const Tab = ({ dashbord, campaign, billing }) => {
  const initState = {
    all: true,
    cpa: false,
    cpc: false,
    cpp: false,

    approved: false,
    pending: false,
    rejected: false,
  };

  const [tab, setTab] = useState(initState);

  return (
    <LayoutContainer>
      <TabContainer>
        <TabNavigationTab>
          <ul>
            <li>
              <a
                href='#all-campaigns'
                className={tab.all ? 'active' : ''}
                onClick={() => setTab(tab => ({ ...initState, all: true }))}
              >
                {billing ? 'All payment' : 'All Campaigns'}
              </a>
            </li>
            <li>
              <a
                href='#cpa'
                className={(tab.cpa || tab.approved) ? 'active' : ''}
                onClick={() =>
                  setTab(tab => ({
                    ...initState,
                    all: false,
                    cpa: true,
                    approved: true,
                  }))
                }
              >
                {billing ? 'Approved' : 'CPA'}
              </a>
            </li>
            <li>
              <a
                href='#cpc'
                className={(tab.cpc || tab.pending) ? 'active' : ''}
                onClick={() =>
                  setTab(tab => ({
                    ...initState,
                    all: false,
                    cpc: true,
                    pending: true,
                  }))
                }
              >
                {billing ? 'Pending' : 'CPC'}
              </a>
            </li>
            <li>
              <a
                href='#cpp'
                className={(tab.cpp || tab.rejected) ? 'active' : ''}
                onClick={() =>
                  setTab(tab => ({
                    ...initState,
                    all: false,
                    cpp: true,
                    rejected: true,
                  }))
                }
              >
                {billing ? 'Rejected' : 'CPP'}
              </a>
            </li>
          </ul>
        </TabNavigationTab>
      </TabContainer>

      <div className='tab-content'>
        {tab.all && dashbord ? (
          <AllCampaignTable />
        ) : tab.all && campaign ? (
          <AllCampaignTab />
        ) : tab.all && billing ? (
          <AllBilling />
        ) : (
          ''
        )}

        {tab.cpa && dashbord ? (
          <CpaTable />
        ) : tab.cpa && campaign ? (
          <CpaTab />
        ) : tab.approved && billing ? (
          <ApprovedBilling />
        ) : (
          ''
        )}

        {tab.cpc && dashbord ? (
          <CpcTable />
        ) : tab.cpc && campaign ? (
          <CpcTab />
        ) : tab.pending && billing ? (
          <PendingBilling />
        ) : (
          ''
        )}

        {tab.cpp && dashbord ? (
          <CppTable />
        ) : tab.cpp && campaign ? (
          <CppTab /> ) : tab.rejected && billing ? (
            <RejectedBilling />
        ) : (
          ''
        )}
      </div>
    </LayoutContainer>
  );
};

export default Tab;
